import { useEffect, useState, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import CabinetsApi from "../services/api/cabinetsApi";

const useCabinetOptions = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const getRadioData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await CabinetsApi.addCabinetRadio();
      
      if (response?.data?.length > 0) {
        setData(response.data);
      }
    } catch (error) {
      console.error("error: ", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getRadioData();
  }, [getRadioData]);

  const groupedOptions = useMemo(() => {
    if (!data.length) return { myDepartment: [], otherDepartments: [], myself: [], base: [] };

    const formattedOptions = data.map((option) => {
      let title = option.title || "";
      let description = option.description || "";

      if (option.id === 1) {
        title = t("based_on_cabinet_setting");
        description = t("based_on_cabinet_setting_description");
      }else if (option.id === 6) {
        description = t("only_open_to_one_department_description");
      } else if ([2, 3, 4, 5].includes(option.id)) {
        description = t("cabinet_settings_description");
      }

      return { ...option, title, description };
    });

    return {
      base: formattedOptions.filter((x) => [1].includes(x.id)),
      myDepartment: formattedOptions.filter((x) => [2, 3, 4, 5].includes(x.id)),
      otherDepartments: formattedOptions.filter((x) => [6, 7, 8, 9].includes(x.id)),
      myself: formattedOptions.filter((x) => [10].includes(x.id)),
    };
  }, [data, t]);

  return useMemo(() => ({
    isLoading,
    ...groupedOptions,
    refetch: getRadioData,
    data: data,
  }), [isLoading, groupedOptions, getRadioData]);
};

export default useCabinetOptions;